import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

interface ITreeMultiSelectObj {
    titleField?: string; // 展示字段
    keyField?: string; // 标识字段
    childrenField?: string; // 子节点
    treeNodes: any[]; // 树节点数据
    defaultCheckedKeys: any[]; // 选中树节点数据
    inputPlaceholder?: string; // 输入框占位符
}

@Component({
    selector: 'clink-tree-multi-select-dialog',
    templateUrl: './tree-multi-select-dialog.component.html',
    styleUrls: ['./tree-multi-select-dialog.component.less'],
})
export class TreeMultiSelectDialogComponent implements OnChanges {
    static config = {
        nzContent: TreeMultiSelectDialogComponent,
        nzWidth: '780px',
        nzComponentParams: {
            data: {
                titleField: 'title',
                keyField: 'key',
                childrenField: 'children',
                treeNodes: [],
                defaultCheckedKeys: [],
                inputPlaceholder: '请输入',
            },
        },
    };
    @Input() data: ITreeMultiSelectObj;
    actionButtons = [{ title: '清空', key: 'clear', isDanger: true }];
    checkedNodes = []; // 被选择数据

    constructor() {}

    ngOnChanges(change: SimpleChanges): void {
        if (change?.data && change?.data.currentValue) {
            const { defaultCheckedKeys } = change?.data.currentValue;
            this.checkedNodes = JSON.parse(JSON.stringify(defaultCheckedKeys ?? []));
        }
    }

    handleActions(type: string): void {
        switch (type) {
            case 'clear': {
                // 清空已选数据
                this.checkedNodes = [];
                this.data.defaultCheckedKeys = [];
                break;
            }
        }
    }

    /**
     * 当前选中数据
     *
     * @param {*} event
     * @memberof TreeMultiSelectDialogComponent
     */
    getCheckedChange(event: any[]): void {
        if (event) {
            this.checkedNodes = [...event];
        }
    }

    /**
     * 删除选中节点
     *
     * @param {*} node
     * @memberof TreeMultiSelectDialogComponent
     */
    removeCheckedNode(node: any, index: number): void {
        this.checkedNodes.splice(index, 1);
        this.data.defaultCheckedKeys = JSON.parse(JSON.stringify(this.checkedNodes));
    }
}
